import { createContext } from 'use-context-selector'
import { OrganizationUploadContextProps } from './types'

export const OrganizationUploadContext = createContext(
  {} as OrganizationUploadContextProps
)
